import { gql } from "apollo-boost";

const REGISTER = gql`
  mutation register(
    $data: String
    $email: String!
    $password: String!
    $origin: String!
  ) {
    register(data: $data, email: $email, password: $password, origin: $origin) {
      is_industry
      token
      analytics_data {
        user_id
        user_type
        flow
      }
    }
  }
`;

export default REGISTER;
